import React from "react";
import {
  getAlertTypeStripeColor,
  handleCreateAlertTypeNoUnderscore,
} from "./AlertsUtils/alertTypeStyles";

export const AlertTypeChip = ({
  alertLabels,
}: {
  alertLabels?: string | null;
}) => {
  const label = handleCreateAlertTypeNoUnderscore(alertLabels);
  if (!label) {
    return null;
  }
  const color = getAlertTypeStripeColor(alertLabels);
  return (
    <span
      className="inline-flex items-center rounded px-1.5 py-0.5 font-mulish text-[10px] font-bold leading-none"
      style={{
        color,
        backgroundColor: `${color}1A`,
        border: `1px solid ${color}59`,
      }}
    >
      {label}
    </span>
  );
};
